import request from '@/util/request'


export const trainSuperviseList = (data) => request.post('/api/trainSuperviseList', data);  //衡量培训效果列表

export const trainSuperviseDetail = (data) => request.post('/api/trainSuperviseDetail', data);  //衡量培训效果详情
